import { render, staticRenderFns } from "./MortgageCaseCard.vue?vue&type=template&id=f4c42620"
import script from "./MortgageCaseCard.vue?vue&type=script&lang=js"
export * from "./MortgageCaseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports